import {configurationsApiHandler} from './configurations';
import {connectivityHubApiHandler} from './connectivityHub';
import {formFieldsApiHandler} from './formFields';
import {organizationsApiHandler} from './organizations';

export const ApiHandler = {
    formFields: formFieldsApiHandler,
    organizations: organizationsApiHandler,
    configurations: configurationsApiHandler,
    connectivityHub: connectivityHubApiHandler,
}